import { useState as S, useRef as P, useCallback as c, useEffect as r, useMemo as Q } from "react";
import { useStore as T, useDispatch as V, useSelector as W } from "react-redux";
import { n as I } from "../noop-378485d5.mjs";
function $(v, D, G, g) {
  const { logger: j, enableLogging: k } = v;
  let { signalRApiUrl: H } = v;
  const { clientIdSelector: M, isSignalROnlineSelector: s } = D ?? {}, { setIsSignalROnlineAction: a } = G ?? {}, {
    useAppStore: q = T,
    useAppDispatch: z = V,
    useAppSelector: B = W
  } = g ?? {}, b = /* @__PURE__ */ new Set();
  function F(i) {
    const [l, J] = S(H), [e, K] = S(null), f = q(), p = z(), A = B(M ?? (() => {
    })), [u, N] = S(!1), [o, L] = S(!1), U = P(u), h = c(() => {
      (s == null ? void 0 : s(f.getState())) === !1 && a && p(a({ isSignalROnline: !0 })), o || L(!0);
    }, [p, o, f]), m = h, C = c(() => {
      (s == null ? void 0 : s(f.getState())) === !0 && a && p(a({ isSignalROnline: !1 })), o && L(!1);
    }, [p, o, f]), O = c(
      async (t) => {
        e && e.groups.indexOf(t) < 0 && await (e == null ? void 0 : e.joinGroup(t));
      },
      [e]
    ), w = c(
      async (t) => {
        e && e.groups.indexOf(t) >= 0 && await (e == null ? void 0 : e.leaveGroup(t));
      },
      [e]
    ), E = c(
      (t, n, d) => e ? e == null ? void 0 : e.addSignalListener(
        t,
        n,
        d
      ) : I,
      [e]
    ), y = c(
      (t, n) => {
        e && e.removeSignalListener(t, n);
      },
      [e]
    ), x = c(() => e ? e.getHubConnectionId() : null, [e]);
    return r(() => {
      let t = !1;
      return import("./SignalR.mjs").then(({ default: n }) => {
        t || K(
          new n({
            signalRApiUrl: l,
            hub: i,
            logger: j,
            enableLogging: k
          })
        );
      }), () => {
        t = !0;
      };
    }, [i, l]), r(() => {
      function t(n) {
        J(n);
      }
      return b.add(t), () => {
        b.delete(t);
      };
    }, []), r(() => {
      U.current = u;
    }, [u]), r(() => {
      const t = e == null ? void 0 : e.addEventListener(
        "connected",
        h
      ), n = e == null ? void 0 : e.addEventListener(
        "reconnected",
        m
      ), d = e == null ? void 0 : e.addEventListener(
        "disconnected",
        C
      );
      return e && !U.current && N(!0), () => {
        t == null || t(), n == null || n(), d == null || d();
      };
    }, [
      e,
      h,
      C,
      m
    ]), r(() => {
      e == null || e.setClientId(A || void 0);
    }, [e, A]), r(() => {
      async function t() {
        await (e == null ? void 0 : e.connect());
      }
      u && t();
    }, [e, u]), r(
      () => () => {
        e == null || e.leaveAllGroups().then(() => {
          e == null || e.disconnect();
        }).catch(I).finally(() => {
          e == null || e.disconnect().catch(I);
        });
      },
      [e]
    ), Q(
      () => ({
        isHubConnected: o,
        join: O,
        leave: w,
        subscribe: E,
        unsubscribe: y,
        getHubConnectionId: x
      }),
      [o, O, w, E, y, x]
    );
  }
  return {
    useSignalR: F,
    setUrl(i) {
      H = i, b.forEach((l) => {
        l(i);
      });
    }
  };
}
export {
  $ as default
};
